import { Table } from "antd";
import { PercelenModel } from "pages/bodem-en-gewas/percelen-old/models/percelenMock";

const fosfaatToestandColumns = [
  {
    title: "Fosfaattoestand",
    key: "omschrijving",
    dataIndex: "omschrijving",
  },
  {
    title: "Grasland",
    key: "palWaardenOmschrijving",
    dataIndex: "palWaardenOmschrijving",
  },
  {
    title: "Bouwland",
    key: "pwWaardenOmschrijving",
    dataIndex: "pwWaardenOmschrijving",
  },
];

export const achtergrondInfo = (
  fosfaattoestandCategorieen: PercelenModel["fosfaattoestandCategorieen"] = [],
  showFosfaat: boolean = true,
) => (
  <>
    <p>
      <b>Achtergrond informatie fosfaattoestand grasland en bouwland</b>
      <br />
      <Table
        columns={fosfaatToestandColumns}
        pagination={false}
        className="table--legend"
        dataSource={fosfaattoestandCategorieen}
      ></Table>
    </p>
    {showFosfaat && (
      <p>
        <br />
        <b>Fosfaat-arme of fosfaat-fixerende gronden</b>
        <br />
        Wilt u van de hogere fosfaatnorm gebruikmaken bij fosfaat-arme of
        fosfaat-fixerende gronden, dan heeft u een analyserapport nodig van een
        erkend geaccrediteerd laboratorium. Het laboratorium maakt gebruik van
        het{" "}
        <a
          rel="noopener noreferrer"
          href="https://www.rvo.nl/sites/default/files/2015/01/02b155b3-240b-4264-828b-c1a4f56a9074.pdf"
          target="_blank"
        >
          Protocol Fosfaatarm en Fosfaatfixerend
        </a>{" "}
        (pdf, 460 kb) om de fosfaattoestand van het perceel te bepalen. Het
        rapport mag op 15 mei van het eerste jaar waarin de hogere
        fosfaatgebruiksnorm gebruikt wordt niet ouder zijn dan 12 maanden. Het
        rapport is 4 jaar geldig, ook voor eventuele nieuwe gebruikers van het
        perceel.
      </p>
    )}
    <p>
      <b>Heeft u grond in het buitenland in gebruik?</b>
      <br />
      Dan dient u deze oppervlakte handmatig op te geven met de verschillende
      gewassen zoals u ook voor percelen in Nederland bij de Gecombineerde
      Opgave doet. Voor de indeling per gewas(perceel) naar fosfaatklassen dient
      u gebruik te maken van de best mogelijk beschikbare gegevens (bij voorkeur
      bodemanalyses).
    </p>
  </>
);
